import React from 'react';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {Col, Container, Row} from "react-bootstrap";
import "./c47_sign.scss";
import {columnLayout} from "../../utils/device";
import {insertHtml} from "../../utils/dom";

interface C47signdata {
    title: string;
    content: string;
    sign:string;
    signimage:string;
    codicefiscale: string
    
}

class C47Sign extends TemplateComponent<C47signdata> {

    componentRender(data: C47signdata): React.ReactElement<any> {

        return (
            <Container className="c47-sign" fluid={true}>
                <Row>
                    <Col {...columnLayout(6)}>
                        <h3 className="title">{data.title}</h3>
                        <div className="content editor-html" {...insertHtml(data.content)} />
                    </Col>

                    <Col {...columnLayout(6)}>
                        <div className="firma">
                        <h3 className="title">{data.sign}</h3>
                        <img className="image" alt="Firma" src={data.signimage}/>
                        </div>
                        <div className="codice">{data.codicefiscale}</div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default C47Sign;